module.exports = __webpack_public_path__ + "img/album22_01.423f11f9.jpg";